export default "__VITE_ASSET__Ck$SfRpp__"